import axios from "axios";

const ibgeInstance = axios.create({
  baseURL: "https://servicodados.ibge.gov.br/api/v1/localidades",
  headers: {
    "Content-Type": "application/json"
  }
});

export { ibgeInstance };
